import { Card, Collapse } from 'antd'
import { InfoItem } from '../../../../../components/infoItem/infoItem'
import { Order } from '../../edit/types'

type Props = {
  order?: Order
}

export const OrderInfo = ({ order }: Props) => {
  if (!order || !order.orderItems?.length) return null

  return (
    <Card size="small" title={`Order #${order.orderId}`} className="mb-3">
      <Collapse
        items={order.orderItems.map((item, index) => ({
          key: String(item.PropertyID),
          label: `Property #${index + 1} — ${item.PropertyName}`,
          children: (
            <>
              <InfoItem label="Property ID" value={item.PropertyID} />
              <InfoItem label="Property name" value={item.PropertyName} />
              <InfoItem label="Number of tokens" value={item.Amount} />
              <InfoItem label="Token price" value={item.TokenPrice} />
              <InfoItem label="Total amount" value={item.Price} />
            </>
          ),
        }))}
      />
    </Card>
  )
}
